import React from 'react';
import { fetchRecordingId } from '../model/util';

const AdminListModal = ({ 
  isOpen, 
  clientObjectArr, 
  userId, 
  acsRoomId,
  socket, 
  senderSocketIdGlobal,
  setAdminListModel, 
  setRecordingTransferModel, 
  setRecordingStatus, 
  openParticipantListForRecording, 
  setIsRecordingModal 
}) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <h2 className='req-record'>Select Admin</h2>
        <p className='record-call'>Please select an admin to transfer the recording.</p>
        <div className='recrd-btn-align'>
          {clientObjectArr.filter(item => item?.userType === 'Admin' && item?.userId !== userId).map(admin => (
            <button key={admin?.userId} onClick={() => {
              const getRecordingId = fetchRecordingId();
              if (getRecordingId) {
                setRecordingStatus('starting');
                openParticipantListForRecording();
                setAdminListModel(false);
                socket.emit('BE-update-status', {
                  acsRoomId,
                  senderUserId: admin?.userId,
                  socketId: senderSocketIdGlobal,
                  data: { recordingId: getRecordingId },
                  type: 'TransferRecording',
                  typeValue: true
                });
                setAdminListModel(false);
                setRecordingTransferModel(false);
                setIsRecordingModal(true);
              }
            }} className='allw-btn'>
              {admin?.displayName}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminListModal;
